<script setup lang="ts">
import type { PdpEcommerceBlockProductPdpMessageSideSlideProps } from '@design-system/components/Pdp/EcommerceBlock/PdpEcommerceBlockProductPdpMessageSideSlide.props'
import { SIDEBAR_IDS } from '@design-system/data/sidebarIds'

const { title, media, message, ctaLabel, cta } =
  defineProps<PdpEcommerceBlockProductPdpMessageSideSlideProps>()
const { currentBrandTheme: brandTheme } = useTheme()
const isDarkTheme = computed(() => brandTheme.value === 'emporio-armani')

const handleNavigateToBAA = () => {
  navigateTo('/' + cta?.internalLink?.urlSlug)
}
</script>

<template>
  <OrganismsSidebarSlide
    :id="SIDEBAR_IDS.pdpMessageSideSlide"
    :header-props="{ titleText: title ?? $ts('pdp.pdpMessage') }"
  >
    <template #body>
      <div
        :class="[
          'space-y-10 border-b pb-8 first-of-type:border-t last-of-type:mb-8 lg:pb-10 lg:last-of-type:mb-10',
          {
            'border-primitives-black': isDarkTheme,
            'border-primitives-white': !isDarkTheme,
          },
        ]"
      >
        <NuxtPicture
          v-if="media?.url?.secure_url"
          provider="cloudinary"
          class="object-contain"
          :src="media?.url?.secure_url"
          :alt="media?.alt ?? ''"
          sizes="600px"
          :img-attrs="{ style: 'height:auto' }"
          placeholder
        />
        <UtilsMarkdown v-if="message" class="text-light-6" :content="message" />
      </div>
    </template>
    <template #footer>
      <div
        class="bg-primitives-white positive-padding z-10 flex items-center justify-center py-6"
      >
        <AtomsCta
          :aria-label="$ts('cart.checkout')"
          :full-width="true"
          @click="handleNavigateToBAA"
        >
          <template #label>
            {{ ctaLabel }}
          </template>
        </AtomsCta>
      </div>
    </template>
  </OrganismsSidebarSlide>
</template>
